import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicCardComponent } from './pages/public-card/public-card.component';

const routes: Routes = [
  {
    path: '',
    component: PublicCardComponent,
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicCardRoutingModule {}
